exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5f9a49f5!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/AreaOverview.vue
// module id = 370
// module chunks = 0